(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var slideshow = document.getElementById('BundleSlideshow');
    if (!slideshow) return;

    var logoImg = document.getElementById('StoreLogoSlideIn');
    var panels = Array.prototype.slice.call(slideshow.querySelectorAll('.bundle-slideshow__panel'));
    var outerBox = slideshow.querySelector(':scope > .bundle-slideshow__controlbox');
    var segments = outerBox ? Array.prototype.slice.call(outerBox.querySelectorAll('.bundle-slideshow__segment')) : [];
    var prevBtn = outerBox ? outerBox.querySelector('.bundle-slideshow__ctrl-arrow--prev') : null;
    var nextBtn = outerBox ? outerBox.querySelector('.bundle-slideshow__ctrl-arrow--next') : null;
    var pauseBtn = outerBox ? outerBox.querySelector('[data-pause-btn]') : null;
    var fallbackSpeed = parseInt(slideshow.dataset.speed, 10) || 6000;
    var current = 0;
    var autoplayTimer = null;
    var isPaused = false;
    var segmentStart = 0;
    var segmentDuration = 0;
    var pausedAt = 0;

    function shuffleArray(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
      return arr;
    }

    var miniCarousel = document.getElementById('BundleReviewsMini');
    var miniSlides = miniCarousel ? Array.prototype.slice.call(miniCarousel.querySelectorAll('.bundle-slideshow__mini-slide')) : [];
    var miniBox = miniCarousel ? miniCarousel.querySelector('.bundle-slideshow__mini-controlbox') : null;
    var miniSegments = miniBox ? Array.prototype.slice.call(miniBox.querySelectorAll('.bundle-slideshow__mini-segment')) : [];
    var miniPrevBtn = miniBox ? miniBox.querySelector('.bundle-slideshow__mini-ctrl-arrow--prev') : null;
    var miniNextBtn = miniBox ? miniBox.querySelector('.bundle-slideshow__mini-ctrl-arrow--next') : null;
    var miniSpeed = miniCarousel ? (parseInt(miniCarousel.dataset.speed, 10) || 8000) : 8000;
    var miniCurrent = 0;
    var miniTimer = null;
    var miniSegmentStart = 0;
    var miniSegmentDuration = 0;
    var miniPausedAt = 0;

    // Show the reviews in a different order each page load.
    if (miniSlides.length > 1) {
      miniSlides = shuffleArray(miniSlides);
    }

    function updateMiniSegments() {
      miniSegmentStart = Date.now();
      miniSegmentDuration = miniSpeed;
      miniSegments.forEach(function (seg, i) {
        var fill = seg.querySelector('.bundle-slideshow__mini-segment-fill');
        seg.classList.remove('is-active');
        if (!fill) return;
        fill.classList.remove('is-animating');
        fill.style.animationDuration = '';
        if (i < miniCurrent) {
          seg.classList.add('is-complete');
          fill.style.width = '100%';
        } else if (i === miniCurrent) {
          seg.classList.remove('is-complete');
          fill.style.width = '0%';
          void fill.offsetWidth;
          fill.style.animationDuration = miniSpeed + 'ms';
          fill.classList.add('is-animating');
          seg.classList.add('is-active');
        } else {
          seg.classList.remove('is-complete');
          fill.style.width = '0%';
        }
      });
    }

    function showMiniSlide(i) {
      if (!miniSlides.length) return;
      miniCurrent = (i + miniSlides.length) % miniSlides.length;
      miniSlides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === miniCurrent); });
      updateMiniSegments();
    }

    function startMiniCarousel(resume) {
      clearTimeout(miniTimer);
      if (!resume) {
        showMiniSlide(0);
      }
      if (miniSlides.length > 1 && !isPaused) {
        var firstWait = resume ? Math.max(50, miniSegmentDuration - (miniPausedAt - miniSegmentStart)) : miniSpeed;
        (function tick(wait) {
          miniTimer = setTimeout(function () {
            showMiniSlide(miniCurrent + 1);
            tick(miniSpeed);
          }, wait);
        })(firstWait);
      }
    }

    function stopMiniCarousel() {
      clearTimeout(miniTimer);
      miniTimer = null;
    }

    function miniGoTo(i) {
      showMiniSlide(i);
      clearTimeout(miniTimer);
      if (miniSlides.length > 1 && !isPaused) {
        (function tick() {
          miniTimer = setTimeout(function () {
            showMiniSlide(miniCurrent + 1);
            tick();
          }, miniSpeed);
        })();
      }
    }

    if (miniPrevBtn) {
      miniPrevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        miniGoTo(miniCurrent - 1);
      });
    }
    if (miniNextBtn) {
      miniNextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        miniGoTo(miniCurrent + 1);
      });
    }
    miniSegments.forEach(function (seg, i) {
      seg.addEventListener('click', function (e) {
        e.stopPropagation();
        miniGoTo(i);
      });
    });

    function replayLogoAnimation() {
      if (!logoImg) return;
      logoImg.classList.remove('is-animating');
      void logoImg.offsetWidth;
      logoImg.classList.add('is-animating');
    }

    function currentDwell() {
      var el = panels[current];
      var dwell = el && el.dataset.dwell ? parseInt(el.dataset.dwell, 10) : fallbackSpeed;
      return dwell || fallbackSpeed;
    }

    function updateSegments() {
      var dwell = currentDwell();
      segmentStart = Date.now();
      segmentDuration = dwell;
      segments.forEach(function (seg, i) {
        var fill = seg.querySelector('.bundle-slideshow__segment-fill');
        seg.classList.remove('is-active');
        if (!fill) return;
        fill.classList.remove('is-animating');
        fill.style.animationDuration = '';
        if (i < current) {
          seg.classList.add('is-complete');
          fill.style.width = '100%';
        } else if (i === current) {
          seg.classList.remove('is-complete');
          fill.style.width = '0%';
          void fill.offsetWidth;
          fill.style.animationDuration = dwell + 'ms';
          fill.classList.add('is-animating');
          seg.classList.add('is-active');
        } else {
          seg.classList.remove('is-complete');
          fill.style.width = '0%';
        }
      });
    }

    function showPanel(index) {
      if (!panels.length) return;
      current = (index + panels.length) % panels.length;
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === current);
      });

      var active = panels[current];
      if (active.classList.contains('bundle-slideshow__panel--intro')) {
        replayLogoAnimation();
      }
      if (active.classList.contains('bundle-slideshow__panel--reviews-wrap')) {
        startMiniCarousel();
      } else {
        stopMiniCarousel();
        showMiniSlide(0);
      }
    }

    function startAutoplay(resume) {
      clearTimeout(autoplayTimer);
      if (!resume) {
        updateSegments();
      }
      if (isPaused) return;
      var active = panels[current];
      if (active && active.classList.contains('bundle-slideshow__panel--bundle-builder')) {
        // Don't yank the shopper away from an in-progress bundle selection.
        // Autoplay stays paused until they manually navigate via the controlbox.
        return;
      }
      if (panels.length > 1) {
        var wait = resume ? Math.max(50, segmentDuration - (pausedAt - segmentStart)) : currentDwell();
        autoplayTimer = setTimeout(function () {
          showPanel(current + 1);
          startAutoplay();
        }, wait);
      }
    }

    function goTo(index) {
      showPanel(index);
      startAutoplay();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () { goTo(current + 1); });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { goTo(current - 1); });
    }
    segments.forEach(function (seg, i) {
      seg.addEventListener('click', function () { goTo(i); });
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        isPaused = !isPaused;
        slideshow.classList.toggle('is-paused', isPaused);
        pauseBtn.setAttribute('data-playing', isPaused ? 'false' : 'true');
        pauseBtn.innerHTML = isPaused ? '&#9654;' : '&#10073;&#10073;';
        pauseBtn.setAttribute('aria-label', isPaused ? 'Play slideshow' : 'Pause slideshow');
        if (isPaused) {
          pausedAt = Date.now();
          miniPausedAt = Date.now();
          clearTimeout(autoplayTimer);
          clearTimeout(miniTimer);
        } else {
          startAutoplay(true);
          var active = panels[current];
          if (active && active.classList.contains('bundle-slideshow__panel--reviews-wrap')) {
            startMiniCarousel(true);
          }
        }
      });
    }

    // Bundle builder blocks: selection, quantity, dynamic pricing, add-to-cart.
    var bundleGrids = Array.prototype.slice.call(slideshow.querySelectorAll('[data-bundle-grid]'));
    bundleGrids.forEach(function (grid) {
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-bundle-tile]'));
      var wrap = grid.closest('.bundle-builder');
      if (!wrap) return;
      var cta = wrap.querySelector('[data-bundle-cta]');
      var priceMath = wrap.querySelector('[data-bundle-price-math]');
      var subtotalEl = wrap.querySelector('[data-bundle-subtotal]');
      var originalEl = wrap.querySelector('[data-bundle-original]');
      var discountedEl = wrap.querySelector('[data-bundle-discounted]');
      var saveEl = wrap.querySelector('[data-bundle-save]');
      var defaultLabel = cta ? (cta.dataset.defaultLabel || cta.textContent.trim()) : '';

      tiles.forEach(function (tile) {
        tile.bundleQty = 0;
      });

      function tileQty(tile) {
        return tile.classList.contains('is-selected') ? (tile.bundleQty || 1) : 0;
      }

      function totalSelectedQty() {
        return tiles.reduce(function (sum, t) { return sum + tileQty(t); }, 0);
      }

      function selectedTiles() {
        return tiles.filter(function (t) { return t.classList.contains('is-selected'); });
      }

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function updateTileQtyUI(tile) {
        var qtyValue = tile.querySelector('[data-qty-value]');
        var qtyMinus = tile.querySelector('[data-qty-minus]');
        var qtyLabel = tile.querySelector('[data-qty-label]');
        var selected = tile.classList.contains('is-selected');
        if (qtyValue) {
          qtyValue.hidden = !selected;
          qtyValue.textContent = tile.bundleQty || 1;
        }
        if (qtyMinus) qtyMinus.hidden = !selected;
        if (qtyLabel) qtyLabel.hidden = !selected;
      }

      function updateBundleState() {
        var selected = selectedTiles();
        var totalQty = totalSelectedQty();
        grid.classList.toggle('is-selecting', selected.length > 0);
        tiles.forEach(function (t) {
          t.classList.toggle('is-dimmed', selected.length > 0 && !t.classList.contains('is-selected'));
        });

        cta.classList.remove('is-almost');

        if (totalQty === 0) {
          if (priceMath) priceMath.hidden = true;
          if (cta) {
            cta.disabled = true;
            cta.textContent = defaultLabel;
            cta.classList.remove('is-active');
          }
          return;
        }

        var totalCents = tiles.reduce(function (sum, t) {
          return sum + (parseInt(t.dataset.price, 10) || 0) * tileQty(t);
        }, 0);

        if (totalQty < 3) {
          if (priceMath) {
            priceMath.hidden = false;
            if (subtotalEl) {
              subtotalEl.hidden = false;
              subtotalEl.textContent = 'Subtotal: ' + formatMoney(totalCents);
            }
            if (originalEl) originalEl.hidden = true;
            if (discountedEl) discountedEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
          if (cta) {
            cta.disabled = true;
            cta.classList.remove('is-active');
            if (totalQty === 2) {
              cta.textContent = 'Just 1 more for 25% off!';
              cta.classList.add('is-almost');
            } else {
              cta.textContent = 'Pick 2 more to unlock 25% off!';
            }
          }
        } else {
          var discountedCents = Math.round(totalCents * 0.75);
          var savedCents = totalCents - discountedCents;
          if (priceMath) {
            priceMath.hidden = false;
            if (subtotalEl) subtotalEl.hidden = true;
            if (originalEl) {
              originalEl.hidden = false;
              originalEl.textContent = formatMoney(totalCents);
            }
            if (discountedEl) {
              discountedEl.hidden = false;
              discountedEl.textContent = formatMoney(discountedCents);
            }
            if (saveEl) {
              saveEl.hidden = false;
              saveEl.textContent = 'You save ' + formatMoney(savedCents) + '!';
            }
          }
          if (cta) {
            cta.disabled = false;
            cta.textContent = 'Add Bundle to Cart';
            cta.classList.add('is-active');
          }
        }
      }

      tiles.forEach(function (tile) {
        var btn = tile.querySelector('[data-bundle-select]');
        var qtyMinus = tile.querySelector('[data-qty-minus]');
        var qtyPlus = tile.querySelector('[data-qty-plus]');
        var qtyValue = tile.querySelector('[data-qty-value]');

        function selectTile() {
          if (tile.classList.contains('is-selected')) return;
          var remaining = 3 - totalSelectedQty();
          if (remaining <= 0) return;
          tile.bundleQty = 1;
          tile.classList.add('is-selected');
          if (btn) btn.setAttribute('aria-pressed', 'true');
          updateTileQtyUI(tile);
          updateBundleState();
        }

        function deselectTile() {
          tile.bundleQty = 0;
          tile.classList.remove('is-selected');
          if (btn) btn.setAttribute('aria-pressed', 'false');
          updateTileQtyUI(tile);
          updateBundleState();
        }

        if (btn) {
          btn.addEventListener('click', function () {
            if (tile.classList.contains('is-selected')) {
              deselectTile();
            } else {
              selectTile();
            }
          });
        }

        if (qtyPlus) {
          qtyPlus.addEventListener('click', function (e) {
            e.stopPropagation();
            if (!tile.classList.contains('is-selected')) {
              selectTile();
              return;
            }
            var otherQty = totalSelectedQty() - (tile.bundleQty || 1);
            if (otherQty + (tile.bundleQty || 1) + 1 > 3) return;
            tile.bundleQty = (tile.bundleQty || 1) + 1;
            if (qtyValue) qtyValue.textContent = tile.bundleQty;
            updateBundleState();
          });
        }

        if (qtyMinus) {
          qtyMinus.addEventListener('click', function (e) {
            e.stopPropagation();
            if (!tile.classList.contains('is-selected')) return;
            tile.bundleQty = (tile.bundleQty || 1) - 1;
            if (tile.bundleQty <= 0) {
              deselectTile();
            } else {
              if (qtyValue) qtyValue.textContent = tile.bundleQty;
              updateBundleState();
            }
          });
        }
      });

      if (cta) {
        cta.addEventListener('click', function () {
          if (totalSelectedQty() !== 3 || cta.disabled) return;
          cta.disabled = true;
          cta.textContent = 'Adding…';
          var items = selectedTiles().map(function (t) {
            return { id: parseInt(t.dataset.variantId, 10), quantity: tileQty(t) };
          });
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              if (!res.ok) { throw new Error('Add to cart failed'); }
              return res.json();
            })
            .then(function () {
              window.location.href = '/cart';
            })
            .catch(function () {
              cta.disabled = false;
              cta.textContent = 'Add Bundle to Cart';
              window.alert('Something went wrong adding the bundle to your cart. Please try again.');
            });
        });
      }

      updateBundleState();
    });

    // Hold off starting the intro logo animation + autoplay until the
    // email popup is out of the way (dismissed, or decided it isn't
    // showing on this page load at all) -- otherwise the popup's opaque
    // overlay was covering the ~1.35s logo animation while it played
    // underneath, unseen. window.maemaePopupState (set synchronously by
    // email-popup.liquid, outside its own DOMContentLoaded handler) covers
    // the case where that state already resolved before we get here; the
    // custom events cover the normal case; the timeout is a safety net if
    // anything about that handshake breaks.
    function beginIntro() {
      showPanel(0);
      startAutoplay();
    }

    if (!document.getElementById('EmailPopup') || window.maemaePopupState === 'dismissed' || window.maemaePopupState === 'not-shown') {
      beginIntro();
    } else {
      var introStarted = false;
      function onPopupResolved() {
        if (introStarted) return;
        introStarted = true;
        beginIntro();
      }
      document.addEventListener('maemae:popup-dismissed', onPopupResolved, { once: true });
      document.addEventListener('maemae:popup-not-shown', onPopupResolved, { once: true });
      // Safety net: don't let the intro hang forever if the popup handshake
      // doesn't fire for some reason.
      setTimeout(onPopupResolved, 6000);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  // Global handshake with bundle-slideshow.liquid: it wants to hold off
  // playing its intro logo animation until this popup is out of the way
  // (dismissed, or never going to show on this page load at all), since
  // the popup's opaque overlay was covering the animation while it played
  // underneath unseen. window.maemaePopupState lets bundle-slideshow check
  // synchronously in case its own listener attaches after we've already
  // resolved (race-safe), while the custom events cover the normal case.
  window.maemaePopupState = window.maemaePopupState || 'pending';

  function maemaeNotifyNotShown() {
    if (window.maemaePopupState === 'dismissed' || window.maemaePopupState === 'not-shown') return;
    window.maemaePopupState = 'not-shown';
    document.dispatchEvent(new CustomEvent('maemae:popup-not-shown'));
  }

  function maemaeNotifyDismissed() {
    if (window.maemaePopupState === 'dismissed') return;
    window.maemaePopupState = 'dismissed';
    document.dispatchEvent(new CustomEvent('maemae:popup-dismissed'));
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('EmailPopup');
    if (!overlay) {
      maemaeNotifyNotShown();
      return;
    }

    var closeBtn = document.getElementById('EmailPopupClose');

    function show() {
      overlay.classList.add('is-visible');
      var input = overlay.querySelector('input[type="email"]');
      if (input) {
        setTimeout(function () { input.focus(); }, 300);
      }
    }

    function hide() {
      overlay.classList.remove('is-visible');
      maemaeNotifyDismissed();
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', hide);
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) hide();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-visible')) hide();
    });

    // If the form just posted (success or validation error), always open
    // immediately so the shopper sees the result of their submission.
    if (overlay.dataset.postedSuccessfully === 'true') {
      show();
      return;
    }

    var delay = parseInt(overlay.dataset.delay, 10);
    if (isNaN(delay)) delay = 0;

    // Toned down per feedback: show once on the very first page load of the
    // session, then only randomly (not every refresh) while they keep
    // browsing, capped so it never gets naggy.
    var SEEN_KEY = 'maemae_popup_seen_once';
    var COUNT_KEY = 'maemae_popup_reshow_count';
    var MAX_RESHOWS = 2;
    var RESHOW_CHANCE = 0.2;

    var seenOnce = false;
    try {
      seenOnce = sessionStorage.getItem(SEEN_KEY) === 'true';
    } catch (e) {}

    if (!seenOnce) {
      try { sessionStorage.setItem(SEEN_KEY, 'true'); } catch (e) {}
      setTimeout(show, delay);
      return;
    }

    var reshowCount = 0;
    try {
      reshowCount = parseInt(sessionStorage.getItem(COUNT_KEY), 10) || 0;
    } catch (e) {}

    if (reshowCount < MAX_RESHOWS && Math.random() < RESHOW_CHANCE) {
      try { sessionStorage.setItem(COUNT_KEY, String(reshowCount + 1)); } catch (e) {}
      setTimeout(show, Math.max(delay, 5000));
      return;
    }

    // Not showing on this particular page load at all.
    maemaeNotifyNotShown();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initOverstockNotices() {
      document.querySelectorAll('[data-overstock-notice]').forEach(function (notice) {
        if (notice.dataset.overstockInit) return;
        notice.dataset.overstockInit = 'true';

        var formId = notice.getAttribute('data-product-form-id');
        var qtyInputId = notice.getAttribute('data-quantity-input-id');
        var availableQty = parseInt(notice.getAttribute('data-available-quantity'), 10) || 0;
        var inventoryManagement = notice.getAttribute('data-inventory-management');
        var inventoryPolicy = notice.getAttribute('data-inventory-policy');
        var cartQty = parseInt(notice.getAttribute('data-cart-quantity'), 10) || 0;
        var form = formId ? document.getElementById(formId) : null;
        var closeButtons = notice.querySelectorAll('[data-overstock-close]');

        function show() {
          notice.classList.add('is-visible');
          document.body.classList.add('overstock-popup-open');
        }

        function hide() {
          notice.classList.remove('is-visible');
          document.body.classList.remove('overstock-popup-open');
        }

        closeButtons.forEach(function (btn) {
          btn.addEventListener('click', hide);
        });

        notice.addEventListener('click', function (e) {
          if (e.target === notice) hide();
        });

        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && notice.classList.contains('is-visible')) hide();
        });

        if (!form) return;

        // Only relevant when Shopify is tracking inventory for this variant.
        // Oversell is allowed store-wide, so we never block submission —
        // we just surface a friendly heads-up when the requested quantity
        // would exceed what's currently on hand.
        if (inventoryManagement !== 'shopify') return;

        form.addEventListener('submit', function () {
          var qtyInput = qtyInputId ? document.getElementById(qtyInputId) : null;
          var requestedQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          var projectedTotal = cartQty + requestedQty;

          if (projectedTotal > availableQty) {
            show();
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOverstockNotices);
    } else {
      initOverstockNotices();
    }

    document.addEventListener('shopify:section:load', initOverstockNotices);
  })();

  (function () {
    if (window.maemaeWishlistPdpInit) return;
    window.maemaeWishlistPdpInit = true;

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem('maemae_wishlist') || '[]');
      } catch (e) {
        return [];
      }
    }

    function setWishlist(arr) {
      localStorage.setItem('maemae_wishlist', JSON.stringify(arr));
      document.dispatchEvent(new CustomEvent('maemae:wishlist-updated', { detail: { wishlist: arr } }));
    }

    function syncButton(btn) {
      var handle = btn.getAttribute('data-product-handle');
      var wishlist = getWishlist();
      var active = wishlist.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    function syncAll() {
      document.querySelectorAll('[data-maemae-wishlist-toggle]').forEach(syncButton);
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-maemae-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-product-handle');
      var wishlist = getWishlist();
      var idx = wishlist.indexOf(handle);
      if (idx === -1) {
        wishlist.push(handle);
      } else {
        wishlist.splice(idx, 1);
      }
      setWishlist(wishlist);
      syncAll();
    });

    document.addEventListener('maemae:wishlist-updated', syncAll);
    document.addEventListener('DOMContentLoaded', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
    syncAll();
  })();

  } catch(e) { console.error(e); }
})();
})();
